import React from 'react';
import {
  SubPageWrapper,
  Indicator,
  Divider,
} from 'legacyComponents/styled/lib';

export const SubPageTextIndicator = () => (
  <SubPageWrapper>
    <Indicator width='70%' height='36px' margin='0px 0px 10px 0px' />
    <Divider />
    <Indicator width='30%' height='16px' margin='10px 0px 0px 0px' />
  </SubPageWrapper>
);
